// extracted by mini-css-extract-plugin
export default {"pageHeader":"PageHeader_pageHeader__f0DI-","tabBarWrap":"PageHeader_tabBarWrap__COAaY","actions":"PageHeader_actions__KAW0i","pageTitle":"PageHeader_pageTitle__JYbeH"};